import { apiRequests, mapApiRequests } from '../utilities/axios-factory'
import store from '../store'

function getAuthHeaders () {
  return {
    Authorization: store.getters.getTokenId
  }
}

function buildParams (params) {
  return params || {}
}

export function getApiOverview () {
  return apiRequests.get('/v1/diagnostics/overview', {
    headers: getAuthHeaders()
  }).then(function (result) {
    return result.data
  })
}

export function getApiProgressiveTicketQueue (params) {
  return apiRequests.get('/v1/diagnostics/progressive-ticket-queue', {
    params: buildParams(params),
    headers: getAuthHeaders()
  }).then(function (result) {
    return result.data
  })
}

export function resetApiProgressiveTicketQueue (transportationProfileId) {
  return apiRequests.post('/v1/diagnostics/progressive-ticket-queue/' + transportationProfileId + '/reset', {}, {
    headers: getAuthHeaders()
  }).then(function (result) {
    return result.data
  })
}

export function getApiProgressivePricingQueue (params) {
  return apiRequests.get('/v1/diagnostics/progressive-pricing-queue', {
    params: buildParams(params),
    headers: getAuthHeaders()
  }).then(function (result) {
    return result.data
  })
}

export function resetApiProgressivePricingQueue (transportationProfileId) {
  return apiRequests.post('/v1/diagnostics/progressive-pricing-queue/' + transportationProfileId + '/reset', {}, {
    headers: getAuthHeaders()
  }).then(function (result) {
    return result.data
  })
}

export function getApiScheduledJobs (params) {
  return apiRequests.get('/v1/diagnostics/scheduled-jobs', {
    params: buildParams(params),
    headers: getAuthHeaders()
  }).then(function (result) {
    return result.data
  })
}

export function runApiScheduledJob (id) {
  return apiRequests.post('/v1/scheduled-job/' + id + '/run/', {}, {
    headers: getAuthHeaders()
  }).then(function (result) {
    return result.data
  })
}

export function getMapApiOverview () {
  return mapApiRequests.get('/v1/diagnostics/overview', {
    headers: getAuthHeaders()
  }).then(function (result) {
    return result.data
  })
}

export function getMapApiWorkerTasks () {
  return mapApiRequests.get('/v1/diagnostics/worker-tasks', {
    headers: getAuthHeaders()
  }).then(function (result) {
    return result.data
  })
}

export function getMapApiRequestQueues () {
  return mapApiRequests.get('/v1/diagnostics/request-queues', {
    headers: getAuthHeaders()
  }).then(function (result) {
    return result.data
  })
}
